import React, { Component, createRef } from "react";

import style from "./AddScore.module.css";

import { ScoreType } from "../../assets/Js/scoreEnum";
import { Spinner } from "../../Components/Spinner/Spinner";
import { callAPI } from "../../assets/Js/backendCommunication";
import { getPlainToken } from "../../assets/Js/tokenHandler";

import projectSettings from "../../assets/Js/projectSettings";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

import { immediateToast } from "izitoast-react";

import { closeModel } from "../../assets/Js/closeModel";

import CustomRep from "./CustomRep";
import CustomWeight from "./CustomWeight";
import checkVideoFormat from "../../assets/Js/isVideoFormatRight";
import { isObjectEmpty } from "../../assets/Js/isObjectEmpty";
import UnitEnum from "../../assets/Js/UnitEnum";
import toTitleCase from "../../assets/Js/titleCase";

export default class AddScore extends Component {
  constructor(props) {
    super(props);
    this.rxScaleRef = createRef();
    this.notesRef = createRef();
    this.scoreArrayRef = createRef();
    this.videoInputRef = createRef();

    this.state = {
      isLoading: false,
      workout: this.props.workout,
      notes: "",
      rxScale: false,
      saveButton: "Save",
      scoreArray: ["false"],
      isLoading: false,
      isDeleteLoading: false,
      editable: false,
      firstInputScore: 0,
      secondInputScore: 0,
      scoreId: null,
      scoreVideo: {},
      deleteButton: false,
      hasUploadVideo: false,
      isVideoInvalidFormat: false,
      WeightPreference: UnitEnum.lbs,
      serverVideo: false,
    };
  }

  componentDidMount() {
    this.createValues();
    this.getScore();
  }

  static getDerivedStateFromProps = (props, state) => {
    return {
      ...state,
      trackWorkoutId: props.trackWorkoutId,
    };
  };

  componentDidUpdate(prevProps, newProps) {
    if (prevProps.trackWorkoutId !== newProps.trackWorkoutId) {
      this.getScore();
    }
  }

  createValues = () => {
    let _scoreType = this.state.workout.ScoreType;

    if (_scoreType) {
      if (ScoreType.roundreps === _scoreType) {
        this.initArray("0+0");
      } else if (ScoreType.time === _scoreType) {
        this.initArray("0:0");
      } else if (ScoreType.reps === _scoreType) {
        this.initArray("0");
      } else if (ScoreType.weight === _scoreType) {
        this.initArray("0");
      }
    }
  };

  getScore = async () => {
    let url = `${projectSettings.baseUrl}/scores/get/${this.props.trackWorkoutId}`;
    let header = true;
    let type = "GET";
    let token = getPlainToken();
    let response = "";
    response = await callAPI(url, header, type, null, token);
    if (response) {
      if (response.type === "error") {
      } else if (response.type === "success") {
        let { Score, UserPreferences } = response.data;

        if (Score) {
          let { notes, values, isscaled, scoreId, videoUrl } = Score;

          this.setState({
            notes: notes,
            scoreArray: values,
            rxScale: isscaled,
            saveButton: "Update",
            deleteButton: true,
            scoreId: scoreId,
            serverVideo: true,
            editable: true,
            scoreVideo: videoUrl ? videoUrl : {},
          });
        }

        this.setState({
          WeightPreference: UserPreferences.WeightPreference,
        });
      }
    }

    if (response.data?.Score?.videoUrl) {
      this.setState({
        hasUploadVideo: true,
      });
    }
  };

  handleScoreChange = (value, index) => {
    let sArray = this.state.scoreArray;
    sArray[index] = value;
    this.setState({
      scoreArray: sArray,
    });
  };

  handlerSubmit = (e) => {
    e.preventDefault();
    this.addScore();
  };

  addScore = async () => {
    let url = `${projectSettings.baseUrl}/scores/save`;
    let header = false;
    let type = "POST";
    let token = getPlainToken();
    let scoreData = new FormData();

    scoreData.append("TrackWorkoutId", this.props.trackWorkoutId);
    scoreData.append("Value", JSON.stringify(this.state.scoreArray));
    scoreData.append("ScoreType", this.state.workout.ScoreType);
    scoreData.append("Sets", this.state.workout.Sets);
    scoreData.append("WorkoutId", this.state.workout.Id);
    scoreData.append("Notes", this.state.notes);
    scoreData.append("IsScaled", this.state.rxScale);

    if (this.state.scoreVideo && this.state.hasUploadVideo) {
      scoreData.append("Video", this.state.scoreVideo);
      scoreData.append("IsMedia", true);
    } else if (!isObjectEmpty(this.state.scoreVideo)) {
      scoreData.append("IsMedia", true);
    } else {
      scoreData.append("IsMedia", false);
    }

    this.state.scoreId && scoreData.append("id", this.state.scoreId);

    let response = "";
    if (response === "") {
      this.setState({ isLoading: true });
    }

    response = await callAPI(url, header, type, scoreData, token);

    if (response) {
      this.state.scoreId
        ? apiResponseToast(
          response.status,
          "updateScore",
          response.data.message
        )
        : apiResponseToast(response.status, "addScore", response.data.message);

      this.setState({ isLoading: false });
      if (response.type === "error") {
      } else if (response.type === "success") {
        let modaId = this.props.modalId
          ? this.props.modalId
          : "addScore" + this.state.workout.Id;
        closeModel(modaId);
        this.props.handleAddScore?.(false);
      }
    }
  };

  initArray = (val) => {
    let _tempVal = [];
    let i;

    for (i = 0; i < this.state.workout.Sets; i++) {
      _tempVal.push(val);
    }

    this.setState({ scoreArray: [..._tempVal] });
  };

  deleteScoreRequest = async () => {
    let url = `${projectSettings.baseUrl}/scores/delete/${this.props.trackWorkoutId}`;
    let header = true;
    let type = "POST";
    let token = getPlainToken();
    let data = null;

    let response = "";

    if (response === "") {
      this.setState({ isDeleteLoading: true });
    }

    response = await callAPI(url, header, type, data, token);

    if (response) {
      apiResponseToast(response.status, "deleteScore");

      this.setState({ isDeleteLoading: false });
      if (response.type === "error") {
      } else if (response.type === "success") {
        response = "";
        this.resetState();
        let modaId = this.props.modalId
          ? this.props.modalId
          : "addScore" + this.state.workout.Id;
        closeModel(modaId);
        this.props.handleAddScore?.(false);
      }
    }
  };

  removeData = (executeThisFunctionWithConsent) => {
    new Promise((resolve) => {
      immediateToast("question", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        id: "question",
        zindex: 9999,
        title: "Delete Request",
        message: "Are you sure about that?",
        position: "center",
        buttons: [
          [
            `<button><b>YES</b></button>`,
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");

              resolve("yes");
            },
            true,
          ],
          [
            `<button>NO</button>`,
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    })
      .then((responce) => {
        executeThisFunctionWithConsent();
      })
      .catch((err) => console.error("error:", err));
  };

  renderScore = () => {
    let array = [];
    if (this.state.workout) {
      let sType = this.state.workout.ScoreType;
      let sets = this.state.workout.Sets;

      if (sType === ScoreType.boolean) {
        return (
          <div className="d-flex align-items-center border p-2 mt-2">
            <span className="ml-5">COMPLETE</span>
            <input
              ref={this.scoreArrayRef}
              className="ml-2 rounded"
              onChange={(e) =>
                this.handleScoreChange(e.target.checked ? "true" : "false", 0)
              }
              type="checkbox"
              checked={
                this.state.scoreArray[0] && this.state.scoreArray[0] === "true"
                  ? true
                  : false
              }
            />
          </div>
        );
      } else if (sType === ScoreType.roundreps) {
        for (let i = 0; i < sets; i++) {
          array.push(
            <CustomRep
              handleChange={this.handleScoreChange}
              index={i}
              editable={this.state.editable}
              values={this.state.scoreArray && this.state.scoreArray[i]}
              seperateSign="+"
              firstInputName="ROUND"
              secondInputName="REPS"
            />
          );
        }
      } else if (sType === ScoreType.time) {
        for (let i = 0; i < sets; i++) {
          array.push(
            <CustomRep
              handleChange={this.handleScoreChange}
              index={i}
              editable={this.state.editable}
              values={this.state.scoreArray && this.state.scoreArray[i]}
              seperateSign=":"
              firstInputName="MIN"
              secondInputName="SEC"
            />
          );
        }
      } else if (sType === ScoreType.deadlift) {
        for (let i = 0; i < sets; i++) {
          array.push(
            <CustomWeight
              handleChange={this.handleScoreChange}
              index={i}
              editable={this.state.editable}
              values={this.state.scoreArray ? this.state.scoreArray[i] : ""}
              placeholder={
                this.state.WeightPreference
                  ? toTitleCase(this.state.WeightPreference)
                  : toTitleCase(UnitEnum.lbs)
              }
            />
          );
        }
      } else if (sType === ScoreType.weight) {
        for (let i = 0; i < sets; i++) {
          array.push(
            <CustomWeight
              handleChange={this.handleScoreChange}
              index={i}
              editable={this.state.editable}
              values={this.state.scoreArray && this.state.scoreArray[i]}
              placeholder={
                this.state.WeightPreference
                  ? toTitleCase(this.state.WeightPreference)
                  : toTitleCase(UnitEnum.lbs)
              }
            />
          );
        }
      } else if (sType === ScoreType.reps) {
        for (let i = 0; i < sets; i++) {
          array.push(
            <CustomWeight
              handleChange={this.handleScoreChange}
              index={i}
              editable={this.state.editable}
              values={this.state.scoreArray && this.state.scoreArray[i]}
              placeholder="REPS"
            />
          );
        }
      } else if (sType === ScoreType.calories) {
        for (let i = 0; i < sets; i++) {
          array.push(
            <div>
              <CustomWeight
                handleChange={this.handleScoreChange}
                index={i}
                editable={this.state.editable}
                values={this.state.scoreArray && this.state.scoreArray[i]}
                placeholder="Calories"
              />
            </div>
          )
        }
      } else if (sType === ScoreType.meters) {
        for (let i = 0; i < sets; i++) {
          array.push(
            <div>
              <CustomWeight
                handleChange={this.handleScoreChange}
                index={i}
                editable={this.state.editable}
                values={this.state.scoreArray && this.state.scoreArray[i]}
                placeholder="Meters"
              />
            </div>
          )
        }
      }
    }

    return array;
  };

  resetState = async () => {
    this.notesRef.current.value = "";
    this.videoInputRef.current.value = "";
    await this.setState({
      hasUploadVideo: false,
      deleteButton: false,
      saveButton: "Add",
      notes: "",
      scoreArray: [],
      editable: false,
      rxScale: false,
      scoreVideo: {},
      scoreId: null,
      localVideo: [],
    });
  };

  forwardScoreDetials = () => {
    this.setState({ showScoreDetails: true });
  };

  newDescription(description) {
    var repsPercentage = {
      percentageValue: "",
      reps: "",
    };
    let i = 0;
    let newDescription = "";
    var str = description;
    do {
      repsPercentage = {
        percentage: "",
        resp: "",
      };

      if (str.indexOf("#") === -1 || str.indexOf("\n") === -1) break;
      let index1 = str.indexOf("#"),
        index2 = str.indexOf("\n");
      var subStr = str.slice(index1, ++index2);
      var repsIndex = subStr.indexOf("Reps");
      var startReps = "#" + (i + 1) + ": ";
      let newPercentage = subStr.slice(repsIndex + 5, subStr.indexOf("%"));
      if (newPercentage === "0" || newPercentage === "100") {
        newPercentage = "";
      }
      repsPercentage = {
        percentage: newPercentage,
        reps: subStr.slice(startReps.length, repsIndex),
      };
      newDescription += `#${i + 1} :  ${repsPercentage.reps}  Reps ${repsPercentage.percentage
        }${repsPercentage.percentage && "%"}\n`;
      str = str.replace(subStr, "");
      i++;
    } while (true);
    return newDescription;
  }

  uploadScoreVideo = async (e) => {
    if (e.target.files[0]) {
      let file = e.target.files[0];
      let fileType = file.type;

      if (checkVideoFormat(fileType)) {
        let reader = new FileReader();
        let url = reader.readAsDataURL(file);

        reader.onloadend = function (e) {
          this.setState({
            localVideo: [reader.result],
            hasUploadVideo: true,
            isVideoInvalidFormat: false,
            scoreVideo: file,
            serverVideo: false,
          });
        }.bind(this);
      } else {
        this.setState({
          hasUploadVideo: false,
          isVideoInvalidFormat: true,
          scoreVideo: {},
          serverVideo: false,
        });
      }
    }
  };

  UnselectVideo = () => {
    // this.videoInputRef.current.value = "";

    this.setState({
      scoreVideo: {},
      hasUploadVideo: false,
      isVideoInvalidFormat: false,
      localVideo: null,
    });
  };

  HandleCancelButton = async (e) => {
    e.preventDefault();
    if (this.state.deleteButton) {
      this.removeData(this.deleteScoreRequest);
    } else {
      let modaId = this.props.modalId
        ? this.props.modalId
        : "addScore" + this.state.workout.Id;
      closeModel(modaId);
      this.props.handleAddScore?.(false);
    }
  };

  render() {
    return (
      <div>
        <form>
          <div
            className={`container mx-auto  row ${style.addScoreContainer} p-0`}
          >
            <div className="col-12 p-0">
              <h6>Description:</h6>
              <p>
                {this.state.workout
                  ? this.state.workout.WorkoutType.toLowerCase() === "deadlift"
                    ? this.newDescription(this.state.workout.Description)
                    : this.state.workout.Description
                  : "No description for this score"}
              </p>
              <h6>Notes:</h6>
              <textarea
                className="form-control mb-2 mt-3 primaryScrollBar"
                id="workoutNotes"
                rows="9"
                placeholder="Notes"
                value={this.state.notes}
                ref={this.notesRef}
                onChange={(e) => {
                  this.setState({ notes: e.target.value });
                }}
              ></textarea>
            </div>

            <div className={`col-lg-6 col-md-6  p-0 col-12 mt-2`}>
              <button
                type="button"
                class={`btn  ${!this.state.rxScale
                  ? "btn-primary primaryBgColor"
                  : "btn-outline-primary"
                  } btn-fw col-6 primaryBorderColor ${style.rxBorder}`}
                onClick={(e) => {
                  this.setState({ rxScale: false });
                }}
              >
                Rx
              </button>
              <button
                type="button"
                class={`btn  ${this.state.rxScale
                  ? "btn-primary primaryBgColor"
                  : "btn-outline-primary"
                  } btn-fw col-6 primaryBorderColor ${style.scaledBorder}`}
                onClick={() => {
                  this.setState({ rxScale: true });
                }}
              >
                Scaled
              </button>
              <div className="mt-2">
                <div className={`${style.uploadVideoBox}`}>
                  {!this.state.hasUploadVideo ? (
                    <>
                      <input
                        ref={this.videoInputRef}
                        type="file"
                        className={`custom-file-input ${style.videoUploadInput} pointerCursor`}
                        id="file"
                        accept="video/mp4,video/x-m4v,video/*"
                        onChange={this.uploadScoreVideo}
                      />
                      <i
                        className={`mdi mdi-cloud-upload ${style.uploadIcon}`}
                      ></i>
                      <p className={`${style.uploadVideoText}`}>Upload video</p>
                    </>
                  ) : (
                    <div className="position-relative w-100">
                      <i
                        onClick={this.UnselectVideo}
                        className={`mdi mdi-close text-danger ${style.crossIcon}`}
                      ></i>

                      <video
                        width="100%"
                        height="195px"
                        controls
                        className="objectFitContain"
                      >
                        <source
                          src={
                            this.state.serverVideo
                              ? projectSettings.baseVideoUrl +
                              this.state.scoreVideo
                              : this.state.localVideo
                          }
                        ></source>
                        Your browser does not allow us to display video.
                      </video>
                    </div>
                  )}
                </div>
                <span
                  className={`${style.videoUplaodText} ${this.state.isVideoInvalidFormat ? "text-danger" : ""
                    }`}
                >
                  * Supported Format Are Ogg, WebM, MPEG-4 and MP4
                </span>
              </div>
            </div>
            <div
              className={`col-lg-6 col-md-6 col-12  p-0 pl-2  primaryScrollBar ${style.renderScore}`}
            >
              {this.renderScore()}
            </div>
          </div>
          <div className="d-flex justify-content-end align-items-center mt-3">
            <button
              className={`basicFatBtnStyle   mr-2 ${style.deleteButton}`}
              type="button"
              onClick={this.HandleCancelButton}
            >
              {this.state.isDeleteLoading ? (
                <div>
                  <Spinner />
                </div>
              ) : (
                <div> {this.state.deleteButton ? "Delete" : "Cancel"}</div>
              )}
            </button>

            <button
              type="submit"
              onClick={this.handlerSubmit}
              className="basicFatBtnStyle primaryBtn"
              disabled={this.state.isLoading}
            >
              {this.state.isLoading ? (
                <div>
                  <Spinner />
                </div>
              ) : (
                <div>{this.state.saveButton}</div>
              )}
            </button>
          </div>
        </form>
      </div>
    );
  }
}
